import { useNavigate } from 'react-router-dom'
import './homepage.scss'
import { useEffect } from 'react';
import { listModule } from './constant';
import { hasAuthority } from '../../modules/utils/Permission';
import { useAuth } from '../../modules/auth';
import { localStorageItem } from '../../modules/utils/LocalStorage';
import { KEY_LOCALSTORAGE } from '../../modules/auth/core/_consts';

export function HomePage() {
  const navigate = useNavigate();
  const authoritesModules = listModule.filter((menu) => hasAuthority(menu.permission));
  let configuration = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)
  
  const { logout} = useAuth();

  const handleButtonClick = (to: string) => {
    navigate(to)
  };

  useEffect(() => {
    // handleGetDsDanhMuc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="main" style={{backgroundImage: `url(${configuration?.background || "/media/images/background.jfif"})`}}>
      <div className="container">
        <div>
            <div className='d-flex justify-content-center spaces mt-10'>
              <img src={configuration?.logo || "/media/logos/logo_xHIS.png"} alt="Logo xHis" className='spaces'/>
            </div>
            <p className="text-uppercase text-left text-white fw-normal heading-3 mt-20 mb-40 spaces fs-22">
              {configuration?.applicationName || "PHẦN MỀM QUẢN LÝ PHÒNG KHÁM"}
            </p>
          </div>
        <div className="button-group">
          {authoritesModules.map((item: any) => (
            <div className="item-button" key={item.permission}>
              <button
                className="btn btn-light-primary fw-bolder btn-homepage"
                onClick={() => handleButtonClick(item?.to)}
              >
                <img src={item?.imgSrc} alt={item?.name}></img>
              </button>
              <span className="title-button">{item?.name}</span>
            </div>
          ))}
        </div>
      </div>
      <div className='icon-button'>
        <i className="bi bi-box-arrow-left cursor-pointer icon" onClick={logout}></i>
      </div>
    </div>
  );
}